export enum AppStatesEnumeration {
  CANCELLED = 'CANCELLED',
  CHECKOUT_ACCOUNT_CHECK = 'CHECKOUT_ACCOUNT_CHECK',
  CHECKOUT_BIZUM = 'CHECKOUT_BIZUM',
  CHECKOUT_COMPLETED = 'CHECKOUT_COMPLETED',
  CHECKOUT_DECLARE = 'CHECKOUT_DECLARE',
  CHECKOUT_DOWNPAYMENT = 'CHECKOUT_DOWNPAYMENT',
  CHECKOUT_DOWNPAYMENT_PROCESSING = 'CHECKOUT_DOWNPAYMENT_PROCESSING',
  CHECKOUT_IDENTIFICATION = 'CHECKOUT_IDENTIFICATION',
  CHECKOUT_INCOME = 'CHECKOUT_INCOME',
  CHECKOUT_LOADING = 'CHECKOUT_LOADING',
  CHECKOUT_OPENBANKING = 'CHECKOUT_OPENBANKING',
  CHECKOUT_PENDING = 'CHECKOUT_PENDING',
  CHECKOUT_PENDING_BIZUM = 'CHECKOUT_PENDING_BIZUM',
  CHECKOUT_PENDING_NEEDS_SELFIE = 'CHECKOUT_PENDING_NEEDS_SELFIE',
  CHECKOUT_PENDING_REJECTED = 'CHECKOUT_PENDING_REJECTED',
  CHECKOUT_PENDING_REJECTED_SCAN_IDS = 'CHECKOUT_PENDING_REJECTED_SCAN_IDS',
  CHECKOUT_PENDING_REVIEW = 'CHECKOUT_PENDING_REVIEW',
  CHECKOUT_PENDING_SCAN_IDS = 'CHECKOUT_PENDING_SCAN_IDS',
  CHECKOUT_SIGNED = 'CHECKOUT_SIGNED',
  CHECKOUT_SIGNING = 'CHECKOUT_SIGNING',
  CHECKOUT_SIGNING_CONTRACTUAL = 'CHECKOUT_SIGNING_CONTRACTUAL',
  CHECKOUT_SIGNING_OTP = 'CHECKOUT_SIGNING_OTP',
  CHECKOUT_SIGNED_PENDING = 'CHECKOUT_SIGNED_PENDING',
  CHECKOUT_VIDEOCALL = 'CHECKOUT_VIDEOCALL',
  CHECKOUT_WORKLIFE = 'CHECKOUT_WORKLIFE',
  DECLINED = 'DECLINED',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  LOADING = 'LOADING',
  NEW = 'NEW',
  PROOF_IDENTITY = 'PROOF_IDENTITY',
  PROCESS_ENDED = 'PROCESS_ENDED',
  SUCCESS = 'SUCCESS',
}
